import publicUrls from "../../../routes/publicUrls";
import React, { useEffect, useState } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import axiosInstant from "../../../axiosInstant";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { getExhibition } from "../../../Model/Auction";
import { Typography, Box, Button, Container } from "@mui/material";
import { encodeId } from "../../../hash";

const responsive = {
  superLargeDesktop: { breakpoint: { max: 4000, min: 3000 }, items: 5 },
  desktop: { breakpoint: { max: 3000, min: 1024 }, items: 4, slidesToSlide: 3 },
  tablet: { breakpoint: { max: 1024, min: 464 }, items: 2 },
  mobile: { breakpoint: { max: 464, min: 0 }, items: 1 },
};

function AuctionBanner() {
  const matches = useMediaQuery("(min-width:1000px)");
  const [details, setDetails] = useState([]);
  const [Tille, setTitle] = useState("");
  const [data1, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function getAuctionOne() {
      try {
        const results = await getExhibition();
        if (results && results.length > 0) {
          setTitle(results[0].d_name);
          setData(results);

          const response = await axiosInstant.get(
            
            `/private-sales/lot?id=${results[0].id}&pgroup=EXHIBITION&search=&cat=`
          );
          setDetails(response.data.msg || []);
        }
      } catch (error) {
        console.error("Error fetching exhibition:", error);
      } finally {
        setLoading(false);
      }
    }
    getAuctionOne();
  }, []);

  const GotoPage = () => {
    if (data1.length > 0) {
      
  
      window.location.href = publicUrls.exhibition(data1[0].c_slug, data1[0].id);
    }
  };

  const gotSinglePage = (auction_id, group, title) => {

    
    window.location.href = publicUrls.privateSale(group, auction_id, title);
  };

  if (loading) return null;

  return (
    <section className="main-slider style1">
      <div className="container">
        <div 
          className="row" 
          style={{ 
            backgroundColor: data1.length ? "#000000" : "#ffffff", // White background kung walang record
            minHeight: "400px",
            display: "flex",
            alignItems: "center"
          }}
        >
          {data1.length > 0 ? (
            /* WITH RECORDS - ORIGINAL BLACK DESIGN */
            <div className="col-xl-12" style={{ 
              textAlign: "center", 
              paddingBottom: "80px", 
              backgroundColor: "#f4f4f2", // Professional Gallery/Museum Background
              padding: matches ? "0 40px 80px 40px" : "0 15px 50px 15px"
            }}>
              
              
              <Box
                sx={{
                  pt: 8,
                  pb: 2,
                  display: "flex",
                  flexDirection: matches ? "row" : "column",
                  justifyContent: "space-between",
                  alignItems: matches ? "flex-end" : "center",
                  borderBottom: "1px solid #d1d1cf", // Subtle divider
                  mb: 6,
                  gap: matches ? 0 : 3
                }}
              >
                <Box sx={{ textAlign: matches ? "start" : "center" }}>
                  <Typography
                    sx={{
                      color: "#1a1a1a", // Deep Charcoal for high readability
                      fontSize: matches ? "2.8rem" : "1.8rem",
                      fontFamily: "'Playfair Display', serif", 
                      fontWeight: 600,
                      lineHeight: 1.1,
                      mb: 1
                    }}
                  >
                    {Tille}
                  </Typography>
                  <Typography
                    sx={{
                      color: "#8c8c8c",
                      fontSize: "0.75rem",
                      fontWeight: 600,
                      letterSpacing: "4px", // Spaced out for luxury feel
                      textTransform: "uppercase",
                    }}
                  >
                    Current Exhibition
                  </Typography>
                </Box>
            
                <Button
                  onClick={GotoPage}
                  variant="text" // Text variant with custom border for minimalist look
                  sx={{
                    color: "#1a1a1a",
                    borderRadius: "0px",
                    px: 0,
                    fontSize: "0.85rem",
                    fontWeight: 700,
                    letterSpacing: "2px",
                    borderBottom: "2px solid #1a1a1a",
                    pb: 0.5,
                    "&:hover": {
                      backgroundColor: "transparent",
                      color: "#666",
                      borderColor: "#666",
                    },
                  }}
                >
                  EXPLORE COLLECTION
                </Button>
              </Box>
            
              
              <Carousel
                responsive={responsive}
                arrows={matches}
                infinite
                autoPlay={false} // Professional: Allow users to appreciate the art at their own pace
                itemClass="carousel-item-padding-40-px"
              >
                {details.map((row, index) => {
                  const img_url = row.image?.[0]?.img_url || "https://placehold.co/400x400/jpg";
                  return (
                    <Box
                      key={index}
                      onClick={() => gotSinglePage(row.data.id, row.data.privateSalesGroup, row.data.title)}
                      sx={{
                        cursor: "pointer",
                        px: 2,
                        transition: "all 0.4s ease",
                        "&:hover .artwork-card": {
                          transform: "translateY(-10px)", // Lift effect
                          boxShadow: "0 20px 40px rgba(0,0,0,0.08)",
                        },
                        "&:hover img": {
                          transform: "scale(1.05)",
                        }
                      }}
                    >
                      
                      <Box
                        className="artwork-card"
                        sx={{
                          backgroundColor: "#ffffff", // Pure white card to pop against gray background
                          p: 2, // Acts like a "matting" for the artwork
                          display: "flex",
                          flexDirection: "column",
                          transition: "all 0.4s ease",
                          boxShadow: "0 4px 15px rgba(0,0,0,0.03)",
                        }}
                      >
                        <Box
                          sx={{
                            height: 400,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            overflow: "hidden",
                            bgcolor: "#f9f9f9", // Slight contrast inside the card
                          }}
                        >
                          <img
                            src={img_url}
                            alt={row.data.title}
                            style={{
                              maxWidth: "100%",
                              maxHeight: "100%",
                              objectFit: "contain",
                              transition: "transform 0.8s cubic-bezier(0.2, 1, 0.3, 1)",
                            }}
                          />
                        </Box>
            
                        
                        <Box sx={{ pt: 4, pb: 2, textAlign: "center" }}>
                          <Typography
                            sx={{
                              fontSize: "0.8rem",
                              color: "#999",
                              fontWeight: 600,
                              textTransform: "uppercase",
                              letterSpacing: "2px",
                              mb: 1
                            }}
                          >
                            {row.data.artist}
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "1.1rem",
                              color: "#1a1a1a",
                              fontFamily: "'Playfair Display', serif",
                              fontWeight: 700,
                              fontStyle: "italic"
                            }}
                          >
                            {row.data.title}
                          </Typography>
                          
                          <Box sx={{ 
                            width: "30px", 
                            height: "1px", 
                            bgcolor: "#d1d1cf", 
                            mx: "auto", 
                            mt: 3 
                          }} />
                        </Box>
                      </Box>
                    </Box>
                  );
                })}
              </Carousel>
            </div>
          ) : (
            /* NO RECORDS - PROFESSIONAL EXHIBITION MESSAGE */
            <div className="col-xl-12">
              <Box 
                sx={{ 
                  textAlign: "center", 
                  py: 10, 
                  px: 2,
                  border: "1px solid #eee",
                  backgroundColor: "#fff" 
                }}
              >
                <Typography 
                  variant="h3" 
                  sx={{ 
                    fontFamily: "serif", 
                    color: "#1a1a1a", 
                    mb: 2,
                    fontWeight: 500,
                    letterSpacing: "1px"
                  }}
                >
                  No Upcoming Exhibition
                </Typography>
                
                <Box sx={{ width: "50px", height: "2px", bgcolor: "#000", mx: "auto", mb: 3 }} />
                
                <Typography 
                  sx={{ 
                    color: "#666", 
                    maxWidth: "600px", 
                    mx: "auto", 
                    fontSize: "1.1rem",
                    lineHeight: 1.6,
                    fontStyle: "italic",
                    mb: 4
                  }}
                >
                  "We are currently curating our next premier showcase. Our professional exhibitions feature exceptional works from distinguished artists."
                </Typography>

                <Typography sx={{ color: "#999", fontSize: "0.9rem", mb: 4 }}>
                  Please check back soon for our upcoming schedule or visit our gallery.
                </Typography>

              </Box>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

export default AuctionBanner;